import React from 'react';
import { Header } from '../Header/Header';

export const ComputerCourse = () => {
  return (
    <div id='computer-courses'>
      <Header />
      <section className='ttm-row introduction-section break-1199-colum clearfix'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 content-area'>
              <div className='ttm-service-single-content-area'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='ttm-service-description'>
                      <div className='section-title with-desc text-center clearfix'>
                        <div className='container'>
                          <h2 className='title'>Career Courses</h2>
                        </div>
                      </div>
                      <div className='container'>
                        <div className='sep_holder_box width-100 mb-20'>
                          <span className='sep_holder'>
                            <span className='sep_line'></span>
                          </span>
                          <span className='sep_holder'>
                            <span className='sep_line'></span>
                          </span>
                        </div>

                        <div className='row mt-15 mb-15'>
                          <div className='col-sm-6'>
                            <ul className='ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey'>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  POST GRADUATE DIPLOMA IN COMPUTER APPLICATION [Fast Track] (PGDCA)
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   DIP. IN PRE PRIMARY FACULTY TRAINING PROGRAMME (DPPFTP)
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  DIPLOMA IN COMPUTER APPLICATION [Fast Track] (DCA)
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   DIPLOMA IN FINANCIAL AND FOREIGN ACCOUNTING (DFFA)

                                </span>
                              </li>
                             
                            
                            </ul>
                          </div>
                          <div className='col-sm-6'>
                            <ul className='ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey'>
                              
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  DATA ENTRY OPERATOR AND OFFICE AUTOMATION (DEOA)

                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  (DCA-11) Diploma in Computer Application (Fast
                                  Tarck)
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   DIPLOMA IN COMPUTER FACULTY TRAINING PROGRAMME (DCFTP)

                                </span>
                              </li>
                            
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='ttm-row introduction-section break-1199-colum clearfix'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 content-area'>
              <div className='ttm-service-single-content-area'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='ttm-service-description'>
                      <div className='section-title with-desc text-center clearfix'>
                        <div className='container'>
                          <h2 className='title'>Certificate Courses</h2>
                        </div>
                      </div>
                      <div className='container'>
                        <div className='sep_holder_box width-100 mb-20'>
                          <span className='sep_holder'>
                            <span className='sep_line'></span>
                          </span>
                          <span className='sep_holder'>
                            <span className='sep_line'></span>
                          </span>
                        </div>

                        <div className='row mt-15 mb-15'>
                          <div className='col-sm-6'>
                            <ul className='ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey'>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  MS OFFICE
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   TALLY
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  PYTHON
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   C++

                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   CDTP

                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   ADOBE PHOTOSHOP

                                </span>
                              </li>
                             
                            
                            </ul>
                          </div>
                          <div className='col-sm-6'>
                            <ul className='ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey'>
                              
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  ADOBE COREL DRAW


                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  JAVA PROGRAMMING
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   DIGITAL LITERACY

                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   EXPERT IN MULTIMEDIA


                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   EXPERT IN GRAPHIC DESIGNING


                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                   PHP & SQL


                                </span>
                              </li>
                             
                            
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className='ttm-row introduction-section break-1199-colum clearfix'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 content-area'>
              <div className='ttm-service-single-content-area'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='ttm-service-description'>
                      <div className='section-title with-desc text-center clearfix'>
                        <div className='container'>
                          <h2 className='title'>Vaccation Courses</h2>
                        </div>
                      </div>
                      <div className='container'>
                        <div className='sep_holder_box width-100 mb-20'>
                          <span className='sep_holder'>
                            <span className='sep_line'></span>
                          </span>
                          <span className='sep_holder'>
                            <span className='sep_line'></span>
                          </span>
                        </div>

                        <div className='row mt-15 mb-15'>
                          <div className='col-sm-6'>
                            <ul className='ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey'>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  C-APT JUNIOR
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  CAPT KIDS

                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  COMPUTER OPERATOR JUNIOR

                                </span>
                              </li>
                              
                            </ul>
                          </div>
                          <div className='col-sm-6'>
                            <ul className='ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey'>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                 COMPUTER WIZ 
                                </span>
                              </li>
                              <li>
                                <i className='fa fa-arrow-circle-right'></i>
                                <span className='ttm-list-li-content'>
                                  PROGRAMMER JUNIOR

                                </span>
                              </li>
                              
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
